// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import ActiveSectionController from "./active_section_controller";
application.register("active-section", ActiveSectionController);

import AdminController from "./admin_controller";
application.register("admin", AdminController);

import AnchorsController from "./anchors_controller";
application.register("anchors", AnchorsController);

import CampaignsController from "./campaigns_controller";
application.register("campaigns", CampaignsController);

import CarouselController from "./carousel_controller";
application.register("carousel", CarouselController);

import CarpoolingController from "./carpooling_controller";
application.register("carpooling", CarpoolingController);

import CheckpointsController from "./checkpoints_controller";
application.register("checkpoints", CheckpointsController);

import ClassicTabsController from "./classic_tabs_controller";
application.register("classic-tabs", ClassicTabsController);

import CookiesBannerController from "./cookies_banner_controller";
application.register("cookies-banner", CookiesBannerController);

import CountCheckboxesController from "./count_checkboxes_controller";
application.register("count-checkboxes", CountCheckboxesController);

import DisciplinesSelectorController from "./disciplines_selector_controller";
application.register("disciplines-selector", DisciplinesSelectorController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import EchartsController from "./echarts_controller";
application.register("echarts", EchartsController);

import EditEventController from "./edit_event_controller";
application.register("edit-event", EditEventController);

import EditItemController from "./edit_item_controller";
application.register("edit-item", EditItemController);

import ExpandController from "./expand_controller";
application.register("expand", ExpandController);

import FormsController from "./forms_controller";
application.register("forms", FormsController);

import LeafletController from "./leaflet_controller";
application.register("leaflet", LeafletController);

import LightboxController from "./lightbox_controller";
application.register("lightbox", LightboxController);

import PicturesController from "./pictures_controller";
application.register("pictures", PicturesController);

import PopupController from "./popup_controller";
application.register("popup", PopupController);

import QrcodeController from "./qrcode_controller";
application.register("qrcode", QrcodeController);

import RegistrationEditController from "./registration_edit_controller";
application.register("registration-edit", RegistrationEditController);

import ScrollToController from "./scroll_to_controller";
application.register("scroll-to", ScrollToController);

import SlimSelectController from "./slim_select_controller";
application.register("slim-select", SlimSelectController);

import SortableController from "./sortable_controller";
application.register("sortable", SortableController);

import StickyStatusController from "./sticky_status_controller";
application.register("sticky-status", StickyStatusController);

import StickyTabsController from "./sticky_tabs_controller";
application.register("sticky-tabs", StickyTabsController);

import SubscriptionController from "./subscription_controller";
application.register("subscription", SubscriptionController);

import TabsController from "./tabs_controller";
application.register("tabs", TabsController);

import TextController from "./text_controller";
application.register("text", TextController);

import ToggleDisplayElementController from "./toggle_display_element_controller";
application.register("toggle-display-element", ToggleDisplayElementController);

import VanillaNestedController from "./vanilla_nested_controller";
application.register("vanilla-nested", VanillaNestedController);
